import UFOLoadHold from '@atlaskit/react-ufo/load-hold';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

const createLoadingComponent = () => {
	return UFOLoadHold({
		name: 'LoadingConfluenceConversationAssistantBundle',
	});
};

export const ConfluenceConversationAssistant: LoadableType<
	Omit<
		{
			onClosePanel?: () => void;
			isSynthetic?: boolean;
			children?: React.ReactNode;
			skipChatUI?: boolean;
		},
		'flags'
	>
> = LoadableLazy({
	loader: async () => {
		// Fetch the outer loadable chunk (loadable-ConversationAssistant) AND
		// the AI-mate @atlassian/conversation-assistant chunk in parallel. Both
		// `import()` calls live inside this LoadableLazy object expression, so
		// LoadableMetaBabelPlugin tags them BOTH with this loadable's id — which
		// causes parcel-reporter-loadable to union both bundle groups into
		// preloadAssets for this loadable. Without the second `import()`, the
		// register chunk that owns modules like
		//   platform/…/atlassian-project-status-update-action-renderer/main.tsx
		// (module id 'iuVKP' on CDN / '2xPvv' in local builds) is not included
		// in this loadable's chunk set, and the runtime throws
		//   `Cannot find module 'iuVKP'`
		// when the outer loader's compiled `.then(() => parcelRequire('iuVKP'))`
		// fires.
		const [outer] = await Promise.all([
			import(/* webpackChunkName: "loadable-ConversationAssistant" */ '../src/main.tsx'),
			// eslint-disable-next-line import/dynamic-import-chunkname
			import(
				/* webpackChunkName: "@atlassian/conversation-assistant" */
				'@atlassian/conversation-assistant/import-conversation-assistant'
			),
		]);
		return outer.ConfluenceConversationAssistant;
	},
	loading: createLoadingComponent,
});
